// extracted by mini-css-extract-plugin
module.exports = {"languageControl":"LanguageControl--languageControl--1aURS","languageControl__item":"LanguageControl--languageControl__item--1Zd7p","active":"LanguageControl--active--1wB_p"};